<template>
  <div>
    <div>
      <div class="d-flex justify-content-between my-3">
        <div class="d-flex ">
          <v-multiselect v-model="params.vehicle_type_ids" placeholder="Search Fleet Type" label="name"
            :options="optionsFleetTypes" :multiple="true" required track-by="id" class="mr-2" style="width: 300px"
            @input="fetchData">
            <span slot="noResult">Fleet type not found.</span>
          </v-multiselect>
          <date-picker type="year" v-model="params.year" @change="fetchData" />
        </div>
        <div class="d-flex">
          <b-button variant="success" style="height: max-content;" @click="handleExportTargetAv" class="text-truncate">
            Export
          </b-button>
        </div>
        <!-- <div class="d-flex">
          <b-input @keyup="fetchData" v-model="params.search" class="mx-2" style="min-width: 200px"
            placeholder="Search..." />
          <b-button variant="primary" style="height: max-content;" @click="show.form = true" class="text-truncate w-100">
            Create Data
          </b-button>
        </div> -->
      </div>
      <template v-if="!loading">
        <div class="overflow-auto relative w-100">
          <table class="w-100 striped-table">
            <thead>
              <th class="p-2 sticky col-1">No</th>
              <th class="p-2 text-truncate sticky col-2">Fleet Category</th>
              <th class="p-2 sticky col-3">Year</th>
              <th v-for="(month, index) in target_per_months" :key="index" class="p-2 col-month text-center">{{
                month.name }}</th>
            </thead>
            <tbody>
              <template v-if="listTargetAvailabilities?.length">
                <tr v-for="(item, index) in listTargetAvailabilities" :key="index">
                  <td class="p-2 sticky col-1" :class="index % 2 == 0 ? 'bg-striped' : 'bg-white'">{{
                    getRowNumber(index) }}</td>
                  <td class="p-2 text-truncate sticky col-2" :class="index % 2 == 0 ? 'bg-striped' : 'bg-white'">{{
                    item?.name
                  }}</td>
                  <td class="p-2 sticky col-3" :class="index % 2 == 0 ? 'bg-striped' : 'bg-white'">{{
                    moment(params?.year).format('YYYY')
                  }}</td>
                  <td v-for="(month, index) in item?.availability_permonth" :key="index"
                    class="p-2 col-month text-center">{{ month?.total }}%</td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="17" class="col-1 sticky p-3">
                    No data here!
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="mt-4 d-flex align-items-center w-100 justify-content-end">
          <b-pagination class="mb-0 mr-3" @change="(page) => {
            meta.page = page
            fetchData()
          }" v-model="meta.page" :total-rows="meta.totalItems" :per-page="meta.perPage" first-number
            align="center"></b-pagination>
          <b-form-select plain v-model="meta.perPage" :options="limitOptions" style="width: 140px;" @input="() => {
              meta.page = 1
              fetchData()
            }"></b-form-select>
        </div>
      </template>
      <div v-else colspan="17" class="d-flex justify-content-center p-5 w-100">
        <b-spinner></b-spinner>
      </div>
    </div>
  </div>
</template>
<script>
import { srActions, fleetsActions } from '@/src/Utils/helper'
import moment from 'moment'
import FormTargetFleetAvailability from '../FormTargetFleetAvailability.vue'
import { saveAs } from 'file-saver'

export default {
  name: 'AvailabilityTarget',
  data() {
    return {
      listTargetAvailabilities: [],
      show: {
        form: false,
        remark: false,
      },
      limitOptions: [
        { value: 10, text: "10 / Page" },
        { value: 25, text: "25 / Page" },
        { value: 50, text: "50 / Page" },
      ],
      remark: '',
      loading: false,
      params: {
        year: moment().toDate(),
        search: '',
        vehicle_type_ids: [],
      },
      target_per_months: [
        {
          month: 1,
          percentage_target: null,
          name: 'Jan',
        },
        {
          month: 2,
          percentage_target: null,
          name: 'Feb',
        },
        {
          month: 3,
          percentage_target: null,
          name: 'Mar',
        },
        {
          month: 4,
          percentage_target: null,
          name: 'Apr',
        },
        {
          month: 5,
          percentage_target: null,
          name: 'May',
        },
        {
          month: 6,
          percentage_target: null,
          name: 'Jun',
        },
        {
          month: 7,
          percentage_target: null,
          name: 'Jul',
        },
        {
          month: 8,
          percentage_target: null,
          name: 'Aug',
        },
        {
          month: 9,
          percentage_target: null,
          name: 'Sepr',
        },
        {
          month: 10,
          percentage_target: null,
          name: 'Oct',
        },
        {
          month: 11,
          percentage_target: null,
          name: 'Nov',
        },
        {
          month: 12,
          percentage_target: null,
          name: 'Dec',
        },
      ],
      optionsFleetTypes: [],
      meta: {
        page: 1,
        perPage: 10,
        totalItems: 10,
        totalPage: 1,
      }
    }
  },
  components: {
    FormTargetFleetAvailability,
  },
  methods: {
    ...srActions,
    ...fleetsActions,
    async fetchData() {
      try {
        this.loading = true
        const body = {
          year: moment(this.params.year).format('YYYY'),
          vehicle_type_ids: this.params?.vehicle_type_ids.map((val) => val.id),
        }
        const { data } = await this.getTargetAvailabilityNew({body, params:this.meta})
        this.listTargetAvailabilities = data.data
        this.meta.totalItems = data.meta.total_item
        this.meta.perPage = data.meta.per_page
        this.meta.totalPage = data.meta.total_pages
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getVehicleType() {
      this.optionsFleetTypes = []
      let { status, data } = await this.getFleetTypes()

      if (status === 'success') {
        this.optionsFleetTypes = data
      }
    },
    findMonth(data, month) {
      return data?.find((el) => el?.month == month)
    },
    getRowNumber(index) {
      return ((this.meta.page - 1) * this.meta.perPage) + (index + 1);
    },
    async handleExportTargetAv() {
      try {
        this.loadingExport = true
        const body = {
          year: moment(this.params.year).format('YYYY'),
          vehicle_type_ids: this.params?.vehicle_type_ids.map((val) => val.id),
        }
        const params = {
          user_id: this.user_id,
          perPage: 9999,
        }
        const res = await this.$store.dispatch('sr/exportTargetAvailability', {
          body: { ...body, export_path: 'target-availabilities/fleet-availability/export' },
          params,
        })
        saveAs(res.data, `percentageOfFleetAvailability_${moment().format('DDMMYYYY')}.xlsx`)
        this.$swal({ title: 'Success Export Data', icon: 'success' })
      } catch (error) {
        console.log(error)
        this.$swal({ title: 'Failed Export Data', icon: 'error' })
      } finally {
        this.loadingExport = false
      }
    },
  },
  mounted() {
    this.fetchData()
    this.getVehicleType()
  },
}
</script>
<style scoped>
.bg-striped {
  background-color: #f9f9f9 !important;
}

table td {
  color: #000 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.relative {
  position: relative;
}

.col-month {
  min-width: 76px;
}

.sticky {
  position: sticky !important;
}

.col-1 {
  left: 0px !important;
  z-index: 20;
  min-width: 40px;
}

.col-2 {
  left: 40px !important;
  z-index: 20;
  min-width: 200px;
  max-width: 200px;
}

.col-3 {
  left: 240px !important;
  z-index: 20;
  min-width: 80px;
  max-width: 80px;
}

.col-4 {
  left: 340px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}

.col-5 {
  left: 440px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
</style>
